/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LinkType } from '../../models/link-type';
import { TrendingActivityResponse } from '../../models/trending-activity-response';
import { TrendingType } from '../../models/trending-type';

export interface GetTrendingActivities$Params {
  search?: string;
  categoryId?: number;
  companyCategoryId?: number;
  companySizeId?: number;
  countryId?: number;
  trendingType: TrendingType;
  periodType?: TrendingType;
  startPeriodDate?: string;
  endPeriodDate?: string;
  isFollowing?: boolean;
  companyTagId?: number;
  departmentId?: number;
  activityTypeValue?: number;
  showNetwork?: boolean;
  networkLinkType?: LinkType;
}

export function getTrendingActivities(http: HttpClient, rootUrl: string, params: GetTrendingActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrendingActivityResponse>>> {
  const rb = new RequestBuilder(rootUrl, getTrendingActivities.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('categoryId', params.categoryId, {});
    rb.query('companyCategoryId', params.companyCategoryId, {});
    rb.query('companySizeId', params.companySizeId, {});
    rb.query('countryId', params.countryId, {});
    rb.query('trendingType', params.trendingType, {});
    rb.query('periodType', params.periodType, {});
    rb.query('startPeriodDate', params.startPeriodDate, {});
    rb.query('endPeriodDate', params.endPeriodDate, {});
    rb.query('isFollowing', params.isFollowing, {});
    rb.query('companyTagId', params.companyTagId, {});
    rb.query('departmentId', params.departmentId, {});
    rb.query('activityTypeValue', params.activityTypeValue, {});
    rb.query('showNetwork', params.showNetwork, {});
    rb.query('networkLinkType', params.networkLinkType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TrendingActivityResponse>>;
    })
  );
}

getTrendingActivities.PATH = '/api/trending-activities';
